<template>
  <div class="content-filter-header">
    <div class="header-title">
      {{ $t("contentFilter.title") }}
    </div>

    <div ref="contentInfo" class="info">
      <div class="info-icon">i</div>

      <div class="info-text">
        {{ $t("howItWorks") }}
      </div>
    </div>

    <div ref="howItWorks" class="how-it-works">
      <h3>{{ $t("contentFilter.title2") }}</h3>

      {{ $t("contentFilter.forEachCategory") }}

      <div class="btn btn-block">
        {{ $t("block") | upperCase }}
      </div>

      {{ $t("contentFilter.blockDescription") }}

      <div class="btn btn-alert">
        {{ $t("alert") | upperCase }}
      </div>

      {{ $t("contentFilter.alertDescription") }}
    </div>
  </div>
</template>

<script>
  import tippy from 'tippy.js'

  export default {
    mounted() {
      this.onHowItWorksClick()
    },

    methods: {
      onHowItWorksClick() {
        tippy(this.$refs.contentInfo,  {
          allowHTML: true,
          content: this.$refs.howItWorks,
          trigger: 'click',
          hideOnClick: true,
          interactive: true,
          theme: 'custom-light',
          placement: 'bottom',
          animation: 'shift-away',
          arrow: true,
          inertia: true,
          duration: [400, 300]
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content-filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    height: 24px;

    .info {
      font-size: 13px;
      display: flex;
      cursor: pointer;

      .info-icon {
        display: flex;
        justify-content: center;

        width: 16px;
        height: 16px;
        font-weight: bold;
        border: 1px solid;
        border-radius: 50%;
        margin-right: 5px;
        padding-top: 1px;
      }

      .info-text {
        padding: 2px 0 0 0;
      }
    }
  }

  .how-it-works {
    width: 330px;
    height: 330px;

    padding: 16px;

    position: relative;
    text-align: left;
    z-index: 9999;

    h3 {
      font-size: 20px;
      padding: 0;
      margin: 0 0 24px 0;
    }

    .btn {
      width: 55px;
      height: 20px;

      font-size: 10px;
      border-radius: 3px;

      padding: 4px 12px;
      margin: 20px 0 15px 0;

      &-block {
        background: #f35f5f;
        color: #fff;
      }

      &-alert {
        background: color.adjust(map.get($colors, secondary), $lightness: -15%);
      }
    }
  }
</style>
